import axios from '../../axios'

/*
 * 院校级投档预估分管理接口
 */

// 创建院校级投档预估分
export const addSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity',
        method: 'POST',
        data
    })
}

// 获取院校级投档预估分详情
export const getSchoolPredictInfo = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/info',
        method: 'GET',
        data
    })
}

// 修改院校级投档预估分信息
export const editSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity',
        method: 'PUT',
        data
    })
}

// 删除院校级投档预估分信息
export const deleteSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索院校级投档预估分信息列表
export const searchSchoolPredictList = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity',
        method: 'GET',
        data
    })
}

// 导入院校级投档预估分
export const importSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/import',
        method: 'POST',
        data
    })
}

// 导出院校级投档预估分
export const exportSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/export',
        method: 'POST',
        data
    })
}

// 批量更新院校级投档预估分
export const updateSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/batch/update',
        method: 'POST',
        data
    })
}

// 院校级投档预估分对比导出
export const diffExportSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/diff/export',
        method: 'POST',
        data
    })
}

// 院校级投档预估分批量删除
export const queryDelSchoolPredict = (data) => {
    return axios({
        url: '/api/data/wish/archive/parity/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/schoolPredict.js